import { useEffect } from "react";

import { Center, Text } from "@/components";

import { useSetTitle } from "@/hooks/useSetTitle";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";

// Being rebuilt to run as a tester, through the same code a tester's texts go
// through.
export const MobileSadieSimulatorPage = () => {
  /* React Hooks */
  useSetTitle({ title: "Sadie Simulator" });

  useEffect(() => {
    mixpanelUtils.trackScreenView(MIXPANEL_SCREENS.SADIE_SIMULATOR);
  }, []);

  /* Render */
  return (
    <Center className="h-svh px-6 text-center">
      <Text className="text-sm font-normal text-slate-500">
        The simulator is being rebuilt.
      </Text>
    </Center>
  );
};
